import { compact } from 'lodash';
import { captureEvent } from '../utils/posthogClient';
import { PH_CTA, PH_DIRECT, PH_PLACEMENT } from '../utils/posthogEvents';
import { initFunnelSession, track } from '../utils/funnelTracking';
import { VIEW_KEYS, EVENT_TYPES } from '../utils/funnelConstants';
import {
  jsonLd,
  medicalWebPageSchema,
  SITE_URL,
} from '../utils/schema';
import dynamic from 'next/dynamic';
import Head from 'next/head';

import React, { useEffect, useState } from 'react';
import {
  ArrowRightLong,
  ArrowRightShort,
  ArrowRightWhite,
  BlueCheckMark,
} from '../assets/icons';
import { Spinner } from 'react-bootstrap';
import { bannerNew, miniModalImg } from '../assets/images';

import Questions from '../components/questions';

import Ribbon from '../components/ribbon';

import { TrustBoxWide } from '../components/trustBox';

import {
  LoadService,
  LoadServiceCategory,
  slimServiceForListing,
} from '../DB/DB';

import { useRouter } from 'next/router';
import Script from 'next/script';
import { BoltWhite, GreenTick, RedCross } from '../assets/icons';
import Link from 'next/link';
import Image from 'next/image';
import { reviewimage, starimages, LogoNew } from '../assets/images';
import BrandTickerNew from '../components/BrandTickerNew';
import HeroHomeNew from '../components/Homepage/HeroHomeNew';
import { Container, Row, Col, Table } from 'react-bootstrap';
import ServicesHomeNew from '../components/servicesHomeNew';
import Branding from '../components/Homepage/Branding';
import MiniModal from '../components/Stand-alone/MicrodosingModal';
import HowItWorks from '../components/common/HowItWorks';
import EDHeroSection from '../components/common/EDHeroSection';
import FeaturedTreatments from '../components/common/FeaturedTreatments';

import ComparisonTable from '../components/common/ComparisonTable';
import CorePrograms from '../components/common/CorePrograms';

const ExpertCare = dynamic(() => import('../components/expertCare'), {
  loading: () => (
    <div className='dynamicContainer'>
      {' '}
      <Spinner animation='border' variant='primary' />{' '}
    </div>
  ),
});
const CategoryCarousel = dynamic(
  () => import('../components/CategoryCarousel'),
  {
    loading: () => (
      <div className='dynamicContainer'>
        {' '}
        <Spinner animation='border' variant='primary' />{' '}
      </div>
    ),
  }
);
const MODAL_KEY = 'miniModalClosed';
export default function Home({ categories = [], allConditions = [] }) {
  const router = useRouter();
  //Functional Programming
  const [showModal, setShowModal] = useState(false);
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    const isClosed = sessionStorage.getItem(MODAL_KEY);
    setShowModal(!isClosed);
    setChecked(true);
  }, []);

  // Funnel baseline: homepage is the entry for funnel 1 (condition picked
  // straight off the homepage). Sessions starting at /services instead are
  // funnel 2 — both are classified from the event sequence at report time.
  useEffect(() => {
    initFunnelSession({ isLoggedInAtEntry: false, isNewUserFlow: true });
    track(VIEW_KEYS.HOME, EVENT_TYPES.VIEWED);
  }, []);

  const handleCloseMiniModal = () => {
    sessionStorage.setItem(MODAL_KEY, 'true');
    setShowModal(false);
  };
  //  if (!checked) return null;

  return (
    <div>
      {/* <Script
        id='GOOGLE_TAG_MANAGER'
        strategy='afterInteractive'
        dangerouslySetInnerHTML={{
          __html: `
              (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','GTM-P9G9VKL');

                `,
        }}
      /> */}
      <Script
        type='text/javascript'
        src='//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js'
        strategy='lazyOnload'
      />
      <Head>
        <title>
          24/7 Virtual Healthcare: Affordable Online Doctor Visits - 24hrdoc
        </title>
        <meta
          name='keywords'
          content='Get fast, affordable, 24/7 online doctor visits with 24hrdoc. Access trusted providers anytime for prescriptions, treatments, and urgent care—stress-free.'
        />
        <link rel='canonical' href='https://www.24hrdoc.com/' />
        <meta
          property='og:image'
          content={
            'https://www.24hrdoc.com/_next/image?url=%2Fassets%2Fimages%2Fnew%2Furgentcare.png&w=640&q=75'
          }
        />
        <meta
          name='description'
          content='Get fast, affordable, 24/7 online doctor visits with 24hrdoc. Access trusted providers anytime for prescriptions, treatments, and urgent care—stress-free.'
        />
        <script
          type='application/ld+json'
          key='homepage-jsonld'
          dangerouslySetInnerHTML={jsonLd(
            medicalWebPageSchema({
              name: '24hrdoc',
              url: `${SITE_URL}/`,
              description:
                'Get fast, affordable, 24/7 online doctor visits with 24hrdoc. Access trusted providers anytime for prescriptions, treatments, and urgent care—stress-free.',
            })
          )}
        />
      </Head>
      {/* <HeroHome allConditions={allConditions} /> */}
      {/* {checked && showModal && <MiniModal onClose={handleCloseMiniModal} />} */}

      <HeroHomeNew allConditions={allConditions} />
      <div className='tw-mb-16 tw-hidden lg:tw-flex' />
      <Ribbon />
      {categories.length > 0 && (
        <ServicesHomeNew
          categories={categories}
          allConditions={allConditions}
        />
      )}
      {/* Third-party programs disabled — FeaturedTreatments links only to
          /weight-loss and /erectile-dysfunction, both now under _programs/. */}
      {/* <FeaturedTreatments /> */}
      <BrandTickerNew />
      {/* <EDHeroSection /> */}

      {/* <CorePrograms /> */}

      {/* <Branding styles='tw-mt-0' /> */}

      {/* the how it works section */}
      <HowItWorks
        subtext={
          <>
            Advanced care — without the complexity. If approved, your
            prescription is <br className='tw-hidden lg:tw-block ' />
            sent to your pharmacy for pickup often within hours.
          </>
        }
        path='services/#conditions'
        showTicker={false}
      />

      {/* the table section */}
      <ComparisonTable CTAtext='Start treatment' />

      {/* <CategoryCarousel categories={categories} /> */}
      {/* the Review Section */}
      <section className='w-full tw-py-10 lg:tw-py-[4.5rem] '>
        <div className='tw-w-[92%] lg:tw-w-[82%] 2xl:tw-w-[90rem] tw-mx-auto tw-flex tw-flex-col tw-gap-y-12lg'>
          <div className='tw-flex tw-flex-col tw-gap-y-8 lg:tw-gap-y-0 md:tw-flex-row lg:tw-items-center lg:tw-justify-between'>
            <div className='tw-relative tw-w-[100%] md:tw-flex-1 tw-h-[270px] tw-rounded-2xl'>
              <Image
                src={reviewimage}
                layout='fill'
                objectFit='cover'
                alt='A-happy-lady'
                className='tw-rounded-2xl'
              />
            </div>
            <div className='md:tw-flex-1 tw-flex tw-flex-col  md:tw-items-center'>
              <div className='tw-flex tw-flex-col tw-gap-y-6'>
                {' '}
                <div className='tw-relative tw-w-[155px] tw-h-[78px]'>
                  <Image
                    src={starimages}
                    layout='fill'
                    objectFit='cover'
                    alt='review-stars'
                  />
                </div>
                <h2 className='tw-font-medium  tw-text-[24px] lg:tw-text-[36px]'>
                  Trusted by over 12,000
                  <br /> patients nationwide
                </h2>
                <p className='tw-m-0'>
                  Fast care, clear guidance, and real results — without waiting
                  rooms or
                  <br className='tw-hidden lg:tw-block' /> hidden fees
                </p>
              </div>
            </div>
          </div>{' '}
          <TrustBoxWide />
        </div>
      </section>
      {/* The banner */}
      <section className='tw-relative tw-w-full tw-h-[500px] lg:tw-h-[650px]'>
        <Image
          src={bannerNew}
          layout='fill'
          objectFit='cover'
          quality={100}
          alt='the-banner-image'
        />
        <div className='tw-relative tw-z-10 tw-mx-auto tw-w-[92%] lg:tw-w-[83%] 2xl:tw-w-[90rem] tw-py-8 lg:tw-py-16 tw-text-white'>
          <div className='tw-flex tw-flex-col'>
            <h2 className='tw-font-semibold tw-text-[2rem] lg:tw-text-5xl tw-mb-8'>
              Get care today — without
              <br className='tw-hidden lg:tw-block' /> the wait
            </h2>
            <ul className='tw-p-0 tw-list-none tw-flex tw-flex-col tw-gap-y-3 lg:tw-gap-y-5 tw-mb-8'>
              <li className='tw-flex tw-items-center tw-gap-x-2'>
                <div className='tw-flex-shrink-0'>
                  <BlueCheckMark stroke={'#fff'} />
                </div>
                <p className='tw-m-0 lg:tw-text-2xl '>
                  Reviewed by a licensed provider
                </p>
              </li>
              <li className='tw-flex tw-items-center tw-gap-x-2'>
                <div className='tw-flex-shrink-0'>
                  <BlueCheckMark stroke={'#fff'} />
                </div>
                <p className='tw-m-0 lg:tw-text-2xl '>
                  Prescription if appropriate
                </p>
              </li>
              <li className='tw-flex tw-items-center tw-gap-x-2'>
                <div className='tw-flex-shrink-0'>
                  <BlueCheckMark stroke={'#fff'} />
                </div>
                <p className='tw-m-0 lg:tw-text-2xl'>
                  Trusted by 12,000+ patients
                </p>
              </li>
            </ul>
            <Link href={`/services#conditions`}>
              <div
                onClick={() =>
                  captureEvent(PH_DIRECT.CLICK, {
                    cta: PH_CTA.START_TREATMENT,
                    placement: PH_PLACEMENT.BANNER,
                  })
                }
                className='tw-p-[0.125rem] tw-rounded-full hero-home-new-cta tw-mt-2  lg:tw-w-[400px] tw-mb-6 lg:tw-mb-8'
                style={{}}
              >
                <div className=' tw-bg-black tw-text-base lg:tw-text-xl tw-py-3 lg:tw-py-4 tw-px-4 tw-flex tw-items-center tw-justify-center tw-rounded-full tw-gap-x-2 tw-cursor-pointer'>
                  <span className='tw-font-medium tw-text-lg xl:tw-text-xl tw-text-white'>
                    Start treatment
                  </span>

                  <ArrowRightShort />
                </div>
              </div>
            </Link>
            <p className='tw-text-sm tw-text-center lg:tw-text-left lg:tw-text-base'>
              Most patients complete their first step in under 3 minutes
            </p>
          </div>
        </div>
      </section>
      {/* <section className='theBannerSection'>
        <Image
          src={bannerNew}
          layout='fill'
          objectFit='cover'
          quality={100}
          alt='the-banner-image'
        />
        <div className='theBannerFilm'>
          <div className='theBannerContent'>
            <h2 className='tw-text-[2rem] lg:tw-text-[3rem]'>
              Get care today — without <br className='tw-hidden lg:tw-block' />
              the wait
            </h2>
            <h2 className='h2Sml'>Consult a doctor from the comfort of home</h2>

            <ul>
              <li>
                <span style={{ flexShrink: '0' }}>
                  {' '}
                  <BoltWhite />
                </span>
                <span>Reviewed by a licensed provider</span>
              </li>
              <li>
                <span style={{ flexShrink: '0' }}>
                  {' '}
                  <BoltWhite />
                </span>
                <span>Prescription if appropriate</span>
              </li>
              <li>
                <span style={{ flexShrink: '0' }}>
                  {' '}
                  <BoltWhite />
                </span>
                <span> Trusted by 10,000+ patients</span>
              </li>
            </ul>
            <Link href={`/services#conditions`}>
              <div
                className='tw-p-[0.125rem] tw-rounded-full hero-home-new-cta tw-mt-2 tw-w-max lg:tw-w-[400px]'
                style={{}}
              >
                <div className=' tw-bg-black tw-text-base lg:tw-text-xl tw-py-3 lg:tw-py-4 tw-px-4 tw-flex tw-items-center tw-justify-center tw-rounded-full tw-gap-x-2 tw-cursor-pointer'>
                  <span className='tw-font-medium tw-text-lg xl:tw-text-xl tw-text-white'>
                    Start treatment
                  </span>

                  <ArrowRightLong />
                </div>
              </div>
            </Link>
          </div>
        </div>
      </section> */}
      <Questions />
    </div>
  );
}

export async function getStaticProps() {
  try {
    const [servicesData, categoriesData] = await Promise.all([
      LoadService('Service'),
      LoadServiceCategory('Service'),
    ]);

    const categories = categoriesData.results.map((ser) => ({
      objectId: ser.objectId,
      title: ser.title ?? null,
      diseases: compact(
        servicesData.results.map((dis) =>
          ser.objectId === (dis.category && dis.category.objectId)
            ? slimServiceForListing(dis)
            : null
        )
      ),
    }));

    const allConditions = servicesData.results.map((c, i) => ({
      ...slimServiceForListing(c),
      id: i,
    }));

    return {
      props: { categories, allConditions },
      revalidate: 3600,
    };
  } catch (err) {
    console.error('getStaticProps /index failed:', err?.message);
    return {
      props: { categories: [], allConditions: [] },
      revalidate: 60,
    };
  }
}
